import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'components/admin/service-providers/ServiceProvidersDetails.css';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import {
  getCompanyData,
  getUserList,
  getUserForm,
  getShowInviteUserModal,
  getShowConfirmationDeleteModal,
} from 'components/admin/service-providers/store/selectors';
import SimpleTable from 'components/shared/table/SimpleTable';
import { formatPhoneNumber } from 'services/utils/text-util';
import {
  setCurrentUserId,
  setShowEditUserModal,
  loadUserForm,
  editUser,
  deleteUser,
  inviteUser,
  setShowConfirmationModal,
} from 'components/admin/service-providers/store/actions';
import UserModal from 'components/admin/service-providers/UserModal';
import { clearUserData } from 'components/admin/service-providers/store/actions';
import SearchBar from 'components/shared/navigation/SearchBar';
import Button from 'components/shared/button/Button';
import { usersApi } from 'services/api/users-api';
import { getCurrentUser } from 'selectors/authentication';

class UserTable extends Component {
  handleCloseEditUserModal = () => {
    const { dispatch } = this.props;
    dispatch(setShowEditUserModal(false));
  };

  handleInviteClient = () => {
    const { dispatch } = this.props;
    dispatch(clearUserData());
    dispatch(setShowEditUserModal(true));
  };

  handleEditUserOnSubmit = (values) => {
    const { dispatch, companyData, user } = this.props;
    if (user) {
      dispatch(editUser(values, companyData.type, companyData.id));
    } else {
      dispatch(inviteUser(values, companyData.type, companyData.id));
    }
  };

  handleDeleteEditUserModal = (response) => {
    const { user, dispatch, companyData } = this.props;
    if (response) {
      dispatch(deleteUser(user, companyData.type, companyData.id));
    }
    dispatch(setShowConfirmationModal(false));
  };

  handleShowConfirmationDelete = () => {
    const { dispatch } = this.props;
    dispatch(setShowConfirmationModal(true));
  };

  handleUserSelection = (user) => {
    const { dispatch } = this.props;
    dispatch(setCurrentUserId(user.id));
    dispatch(loadUserForm(user));
    dispatch(setShowEditUserModal(true));
  };

  handleResendInvite = (id) => {
    usersApi.resendInvite(id);
  };

  actionBtns(currentUser, user) {
    return (
      <div className="action-btns-wrapper">
        <span
          className="linkable action-btn"
          onClick={() => this.handleUserSelection(user)}
        >
          Edit
        </span>
        {usersApi.resendInviteLink(currentUser, user) ? (
          <span
            className="linkable action-btn"
            onClick={() => this.handleResendInvite(user.id)}
          >
            Resend Invite
          </span>
        ) : (
          ''
        )}
      </div>
    );
  }

  mapServiceProviders = (serviceProviders) => {
    const { currentUser } = this.props;

    return serviceProviders.map((serviceProvider) => {
      return [
        serviceProvider.first_name !== null
          ? `${serviceProvider.first_name} ${serviceProvider.last_name}`
          : 'N/A',
        <span className="h4">{serviceProvider.title}</span>,
        <ContractorStatus status={serviceProvider.status} />,
        serviceProvider.email !== null ? serviceProvider.email : 'N/A',
        `${formatPhoneNumber(serviceProvider.phone_number)}${
          serviceProvider.phone_ext ? ` ext ${serviceProvider.phone_ext}` : ''
        }`,
        this.actionBtns(currentUser, serviceProvider),
      ];
    });
  };

  render() {
    const {
      users,
      showInviteUserModal,
      showConfirmationDeleteModal,
      type,
    } = this.props;
    return (
      <div>
        {users && (
          <div className="content-container">
            <SearchBar
              addButton={
                <Button
                  id="invite-user"
                  className="button-orange"
                  label="Invite User"
                  onClick={this.handleInviteClient}
                />
              }
            >
              &nbsp;
            </SearchBar>
            <SimpleTable
              className="service-providers-table"
              headers={['NAME', 'TITLE', 'STATUS', 'EMAIL', 'PHONE', 'ACTIONS']}
              rows={this.mapServiceProviders(users)}
              emptyMessage="No Users"
            />
          </div>
        )}
        {showInviteUserModal && (
          <UserModal
            show={true}
            companyType={type}
            handleSubmit={this.handleEditUserOnSubmit}
            handleClose={this.handleCloseEditUserModal}
            handleDelete={this.handleShowConfirmationDelete}
            initialValues={this.props.user}
          />
        )}
        {showConfirmationDeleteModal && (
          <ConfirmationModal
            show={showConfirmationDeleteModal}
            message={'Are you sure you want to delete this user?'}
            onHide={this.handleDeleteEditUserModal}
          />
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    companyData: getCompanyData(state),
    users: getUserList(state),
    user: getUserForm(state),
    showInviteUserModal: getShowInviteUserModal(state),
    showConfirmationDeleteModal: getShowConfirmationDeleteModal(state),
    currentUser: getCurrentUser(state),
  };
})(UserTable);



// WEBPACK FOOTER //
// ./src/components/admin/service-providers/UserTable.js